import { StoreOperation } from "@/entity/warehouse/Operations/OperationsMove";
import {IOperationsMoveRepository} from "@/repository/warehouse/Operations/Move/OperationsMoveRepository.types";
import {ResponseDataType} from "@/form/form.types";
import Api from "@/repository/api";

export class OperationsMoveRepository implements IOperationsMoveRepository {
    async OperationAction(data:StoreOperation):Promise<ResponseDataType> {
    const res =  await Api.post('/store/operation/move', data)
    return res.data
    }
}